import { Link, useNavigate } from 'react-router';
import { CloseIcon } from '../../assets/icon/svg';

export default function UnauthorizedPage() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <main className="relative flex min-h-dvh w-full flex-col overflow-hidden bg-[#f8fafc]">
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute left-1/2 top-0 h-64 w-64 -translate-x-1/2 rounded-full bg-[#186cb2]/5 blur-3xl" />
            </div>
            <div className="relative flex flex-1 items-center justify-center px-4 py-8 sm:px-6">
                <div className="w-full max-w-sm">
                    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                        <div className="px-5 pt-6 text-center sm:px-6 sm:pt-7">
                            <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-red-50 text-red-500">
                                <CloseIcon  />
                            </div>
                            <h1 className="mt-4 text-base font-semibold text-gray-800">
                                Access Restricted
                            </h1>
                            <p className="mx-auto mt-1 max-w-xs text-xs leading-5 text-gray-500">
                                You don't have permission to access this page. Please return to the previous page or sign in with an authorized account.
                            </p>
                        </div>
                        <div className="mt-6 flex flex-col-reverse gap-2 border-t border-gray-100 px-5 py-4 sm:flex-row sm:justify-center sm:px-6">
                            <button
                                type="button"
                                onClick={handleGoBack}
                                className="flex w-full items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 sm:w-auto"
                            >
                                <span>←</span>
                                Go Back
                            </button>
                            <Link
                                to="/login"
                                className="flex w-full items-center justify-center gap-2 rounded-md bg-[#186cb2] px-4 py-2 text-xs font-medium text-white transition-colors hover:bg-[#155b96] focus:outline-none focus:ring-2 focus:ring-[#186cb2]/30 sm:w-auto"
                            >
                                Go to Login
                                <span>→</span>
                            </Link>
                        </div>
                    </div>
                    <p className="mt-4 text-center text-[10px] text-gray-400 sm:text-xs">
                        &copy; {new Date().getFullYear()} Phillife. All rights reserved.
                    </p>
                </div>
            </div>
        </main>
    );
}